'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.afterApiSortAndBucketFields = afterApiSortAndBucketFields;

function afterApiSortAndBucketFields(context, config, next) {
    var apiParsedResponseList = context.apiParsedResponseList,
      apiMergedResponse = {},
      numberOfBuckets,
      parsedResponseArray,
      bucketSize;

    numberOfBuckets = config.numberOfBuckets;

    _.forEach(config.seriesToBucket, function (field) {
        parsedResponseArray = apiParsedResponseList[index][field];
        if (parsedResponseArray.length < numberOfBuckets) {
            numberOfBuckets = parsedResponseArray.length;
        }
        parsedResponseArray = parsedResponseArray.sort(function (a, b) {
            return a - b;
        });
        bucketSize = Math.ceil(parsedResponseArray.length / numberOfBuckets);
        apiMergedResponse[field] = {};
        _.forEach(_.range(numberOfBuckets), function (index) {
            if (index < numberOfBuckets - 1) {
                apiMergedResponse[field][((index + 1) * 100) / numberOfBuckets + '%'] =
                  parsedResponseArray[bucketSize * (index + 1)];
            } else {
                //for last element
                apiMergedResponse[field][((index + 1) * 100) / numberOfBuckets + '%'] =
                  parsedResponseArray[parsedResponseArray.length - 1];
            }
        });

    });
    context.apiMergedResponse = apiMergedResponse;
    next();
}